import { createMuiTheme, Theme } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { defaultsDeep } from 'lodash';

import getThemePropsLuma from './getThemePropsLuma';

const colorSuccess = '#25a575';
const colorDanger = '#E13248';
const colorDangerHover = darken(colorDanger, 0.2);
const colorAccentAloe = '#59BF94';
const colorAccentPeach = '#FFDBC6';
const colorAccentWatermelon = '#D7797E';
const colorSupportPowder = '#CDE7ED';
const colorSupportSlate = '#4E6170';
const colorSupportSteel = '#617988';
const colorLightBlue = '#BFDCE3';
const colorSupportMidnight = '#182538';
const colorSupportSnow = '#F0F6F7';
// Temp colors for LumaBot
const colorLochmara = '#0178BD';
const colorBoulder = '#797979';

export const getTheme = (options: Partial<ThemeOptions> = {}) => {
  let defaultOptions: ThemeOptions = {
    typography: {
      useNextVariants: true,
    },
    // @ts-ignore configure all colors defined on `createMuiTheme.d.ts`
    custom: {
      // @ts-ignore
      palette: {
        colorAccentAloe,
        colorAccentPeach,
        colorAccentWatermelon,
        colorDanger,
        colorDangerHover,
        colorSuccess,
        colorSupportSlate,
        colorSupportSteel,
        colorLightBlue,
        colorSupportMidnight,
        colorSupportPowder,
        colorSupportSnow,
        // Temp colors for LumaBot
        colorLochmara,
        colorBoulder,
      },
    },
  };
  defaultOptions = getThemePropsLuma(defaultOptions);
  return createMuiTheme(defaultsDeep({}, options, defaultOptions));
};

/**
 * @deprecated Use `import { Theme } from '@material-ui/core'`
 */
export type LumaTheme = Theme & {
  custom?: any;
};
